import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Grid, Button, Typography } from '@mui/material';

import { gridSpacing } from 'store/constant';
import { getPlannerInfluencersES } from 'api_handlers/es';
import { getCreatorMarketplaceInfluencers } from 'api_handlers/creatorMarketplace';
import { isCreatorMarketplaceBrand } from 'components/utils';
import InfluencerList from '../InfluencerList';
import Search from '../Search';
import AiInfluencerList from '../AiInfluencersList';
import CreatorMarketplaceList from './CreatorMarketplaceList';
import { addFilterInPayload } from 'actions/planner2';


class InfluencerDiscover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: [],
      aiMode: false,
      aiInfluencers: [],
      aiLoading: false,
      aiQuery: '',
      aiTotalResults: 0,
      aiDetectedLocation: null,
      platform: 'instagram',
      page: 1,
      isPlatformChange: false,
      sortBy: 'relevancy',
      sorting: "true",
      // Creator Marketplace (Meta) — self-contained source, independent of Redux/ES.
      cmMode: false,
      cmInfluencers: [],
      cmLoading: false,
      cmTotal: 0,
      cmSample: false,
    };
  }

  toggleCreatorMarketplace = () => {
    const on = !this.state.cmMode;
    this.setState({ cmMode: on });
    if (on) this.fetchCreatorMarketplace(1);
  };

  fetchCreatorMarketplace = async (page = 1) => {
    try {
      this.setState({ cmLoading: true });
      const resp = await getCreatorMarketplaceInfluencers(page, {
        platform: 'instagram',
        country: 'IN',
      });
      this.setState({
        cmInfluencers: resp.results,
        cmTotal: resp.count,
        cmSample: Boolean(resp.__sample),
        cmLoading: false,
      });
    } catch (err) {
      console.error('Error fetching creator marketplace influencers:', err);
      this.setState({ cmLoading: false });
    }
  };

  updateFilters = ({ sortBy }) => {
    this.props.addFilterInPayload('sortBy', sortBy, "true");
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page) {
      this.fetchAiInfluencers(this.state.page, this.state.aiQuery);
    } else if (prevState.platform !== this.state.platform) {
      // this.handleSearch(1,this.state.aiQuery='')
      // this.fetchAiInfluencers(1,'nullksjdklsjhdkjdljd')
      this.setState({ isPlatformChange: true });
    } else if (prevState.sortBy !== this.state.sortBy) {
      // this.handleSearch(1,this.state.aiQuery='')
      // this.fetchAiInfluencers(1,'nullksjdklsjhdkjdljd')
      this.setState({ sorting: "true" });
      this.setState({sortBy: this.state.sortBy }, () => {
        this.fetchAiInfluencers(1, this.state.aiQuery, "true", this.state.sortBy, 'desc');
      });
    }
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.platform !== this.state.platform) {
  //     // this.handleSearch(1,this.state.aiQuery='')
  //     // this.fetchAiInfluencers(1,'nullksjdklsjhdkjdljd')
  //     this.setState({isPlatformChange:true})
  //   }
  // }

  fetchAiInfluencers = async (
    page,
    searchQuery = '',
    sorting = this.state.sorting,
    sort_by = this.state.sortBy,
    sort_order = 'desc',
  ) => {
    try {
      this.setState({ aiLoading: true });
      // const payload = {"payload" :{
      //       "campaign-level-requirements": {
      //           "price-per-creator": 10000000000
      //       },
      //       "creator-level-requirements": {
      //           "platform": "instagram"
      //       },
      //       "advance-filters": {
      //           "sortOrder": "desc",
      //           "sortBy": "category"
      //       },
      //       'query': "food influencers from South India",
      //       "setReset": false
      //   }
      // }
      // const payload = {
      //   'campaign-level-requirements': {},
      //   'creator-level-requirements': {},
      //   'advance-filters': {},
      //   'query': this.state.aiMode ? searchQuery : '',

      //   'setReset': false,
      // };

      const payload = this.state.aiMode
        ? {
            // 'campaign-level-requirements': {},
            // 'creator-level-requirements': {},
            // 'advance-filters': {},
            // 'query': searchQuery,

            // 'setReset': false,
            'campaign-level-requirements': {
              'price-per-creator': 10000000000,
            },
            'creator-level-requirements': {
              platform: this.state.platform,
            },
            'advance-filters': {
              sortOrder: 'desc',
              sortBy: 'category',
            },
            query: searchQuery,
            'aiSorting': sorting,
            'ai_sort_by': sort_by,
            setReset: false,
          }
        : {
            'campaign-level-requirements': {
              'price-per-creator': 10000000000,
            },
            'creator-level-requirements': {
              platform: this.state.platform,
            },
            'advance-filters': {
              sortOrder: 'desc',
              sortBy: 'category',
            },
            setReset: false,
          };

      const response = await getPlannerInfluencersES(payload, page);
      console.log('AI INFLUENCERS RESPONSE: ', response);
      const data = await response.json();

      const results = data?.results || [];
      const total = data?.count || results.length;
      // if (this.state.aiMode && page === 1) {
      //   mixpanel.track('planner_discover', {
      //     action: 'ai_search_results',
      //     data: {
      //       platform: this.state.platform,
      //       result_count: total,
      //     },
      //   });
      // }
      this.setState({
        aiInfluencers: results,
        aiTotalResults: total,
        aiLoading: false,
        aiDetectedLocation: data?.query_metadata?.detected_location || null,
      });
    } catch (err) {
      console.error('Error fetching influencers:', err);
      // if (this.state.aiMode) {
      //   mixpanel.track('planner_discover', {
      //     action: 'ai_search_error',
      //     data: { platform: this.state.platform },
      //   });
      // }
      this.setState({ aiLoading: false });
    }
  };

  handleSearch = async (searchValue) => {
    this.setState({ aiQuery: searchValue });
    if (this.state.aiMode && searchValue.trim()) {
      await this.fetchAiInfluencers(1, searchValue, "true", 'relevancy', 'desc');
    } else {
      await this.fetchInfluencers(1);
    }
    this.setState({ isPlatformChange: false });
  };

  render() {
    const { influencers, loading, totalResults } = this.props;
    // Creator Marketplace (Meta) is gated to the "facebook" brand only.
    const showCreatorMarketplace = isCreatorMarketplaceBrand(
      JSON.parse(localStorage.getItem('user') || 'null'),
    );
    console.log('sort', this.state.sortBy, this.state.sorting);

    return (
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12} md={12}>
          <Search
            aiMode={(value) => this.setState({ aiMode: value })}
            fetchInfluencers={this.fetchInfluencers}
            plannerFilter={async (val) => await this.setState({ filters: val })}
            onSearch={this.handleSearch}
            platform={(value) => this.setState({ platform: value })}
            aiSearchLoading={this.state.aiLoading}
          />
        </Grid>
        {showCreatorMarketplace && (
        <Grid item xs={12} md={12}>
          <Button
            variant={this.state.cmMode ? 'contained' : 'outlined'}
            color="secondary"
            size="small"
            onClick={this.toggleCreatorMarketplace}
          >
            {this.state.cmMode ? '✓ Creator Marketplace (Meta)' : 'Creator Marketplace (Meta)'}
          </Button>
          {this.state.cmMode && this.state.cmSample && (
            <Typography
              sx={{
                mt: 1,
                p: '8px 12px',
                fontSize: 13,
                borderRadius: 1,
                background: '#fff7ed',
                border: '1px solid #fed7aa',
                color: '#9a3412',
              }}
            >
              Showing <b>sample</b> Creator Marketplace data (preview). Real Meta creators appear once
              the backend proxy and advanced access are live.
            </Typography>
          )}
        </Grid>
        )}
        <Grid item xs={12} md={12}>
          {this.state.cmMode && showCreatorMarketplace ? (
            <CreatorMarketplaceList
              creators={this.state.cmInfluencers}
              loading={this.state.cmLoading}
              total={this.state.cmTotal}
            />
          ) : !this.state.aiMode ? (
            <InfluencerList
              isDiscover={true}
              influencers={influencers}
              loading={loading}
              totalResults={totalResults}
              updateFilters={this.updateFilters}
              useCategorySort={true}
              filters={this.state.filters}
            />
          ) : (
            <AiInfluencerList
              isDiscover={true}
              influencers={this.state.isPlatformChange ? [] : this.state.aiInfluencers}
              loading={this.state.aiLoading}
              totalResults={this.state.isPlatformChange ? 0 : this.state.aiTotalResults}
              updateFilters={this.updateFilters}
              useCategorySort={true}
              onSortChange={(val) => this.setState({ sortBy: val })}
              filters={this.state.filters}
              onPageChange={(value) => this.setState({ page: value })}
              detectedLocation={this.state.aiDetectedLocation}
            ></AiInfluencerList>
          )}
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  payload: state.planner2.payload,
  loading: state.planner2.loading,
  influencers: state.planner2.influencers,
  totalResults: state.planner2.totalInfluencersCount,
});

const actionPlanner = {
  addFilterInPayload: addFilterInPayload,
};

// export default Planner;
export default connect(mapStateToProps, actionPlanner)(InfluencerDiscover);
